import { TextField } from "@mui/material";
import React from "react";
import { isValidNumber } from "../../../../utils/IsValidNumber";
interface WeightInputProps {
	value: number | string;
	onChange: (value: string) => void;
	error: boolean;
	helperText: string | undefined;
	className?: string;
}

export const WeightInput: React.FC<WeightInputProps> = ({
	value,
	onChange,
	error,
	helperText,
	className,
}) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const inputValue = e.target.value;

		if (isValidNumber(inputValue)) {
			onChange(inputValue);
		}
	};

	const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		const inputValue = e.target.value;

		if (!inputValue || inputValue.trim() === "") {
			onChange("");
		} else {
			const numValue = parseFloat(inputValue);
			if (numValue <= 0) {
				onChange("");
			}
		}
	};

	return (
		<TextField
			error={error}
			helperText={helperText}
			value={value}
			onChange={handleChange}
			onBlur={handleBlur}
			label={"lbs"}
			fullWidth
			variant="outlined"
			size="small"
			onFocus={(e) => e.target.select()}
			className={className}
			required
		/>
	);
};
